import { SelectButton, ParamsModal, ParamsForm, IrAcademy } from './ui';

export const Export = {
  SelectButton,
  ParamsModal,
  ParamsForm,
  IrAcademy,
};
